import { useEffect, useState } from "react";
import CurrencyConverter from "./currency/Converter";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { ArrowRight, Shield, Globe, Zap } from "lucide-react";

// Read backend URL from .env
const BASE_URL = process.env.REACT_APP_BACKEND_URL;

const HeroSection = () => {
  const { t, i18n } = useTranslation();
  const [hero, setHero] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHero();
  }, []);

  const fetchHero = async () => {
    try {
      console.log("Backend URL:", BASE_URL);

      const res = await axios.get(`${BASE_URL}/api/hero`);

      // If API returns array, take first item
      const heroData = Array.isArray(res.data) ? res.data[0] : res.data;

      setHero(heroData);
    } catch (err) {
      console.error(
        "Hero fetch error:",
        err.response?.data || err.message
      );
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (!hero) return <div>Hero data not found.</div>;

  return (
    <section
      id="home"
      className="relative overflow-hidden min-h-screen flex items-center"
      style={{
        backgroundImage: `
          linear-gradient(rgba(0, 0, 0, 0.86), rgba(0, 0, 0, 0.71)),
          url('/sendora_emotional.png')
        `,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Optional background blur decorations */}
      <div className="absolute inset-0">
        <div className="absolute top-20 right-20 w-96 h-96 rounded-full bg-green-300 opacity-10 blur-3xl" />
        <div className="absolute bottom-20 left-10 w-72 h-72 rounded-full bg-primary-light opacity-10 blur-3xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 pt-32">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/80 backdrop-blur-sm border border-blue-200 mb-8 shadow-sm">
              <Shield className="w-4 h-4 text-primary" />
              <span className="text-sm font-medium text-primary-dark">
                {hero.badge_text}
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white">
              {hero.title}{" "}
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary to-primary">
                {hero.highlight_text}
              </span>
            </h1>

            <p className="text-lg text-white mb-10 max-w-lg leading-relaxed">
              {hero.description}
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={hero.primary_button_link || "/login"}
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl bg-primary text-white font-semibold text-base hover:brightness-110 transition shadow-lg"
              >
                {t("get_started")} 
                <ArrowRight className="w-5 h-5" />
              </a>

              <a
                href={hero.secondary_button_link || "/login"}
                className="inline-flex items-center justify-center px-8 py-4 rounded-xl bg-white/80 backdrop-blur-sm border border-blue-900/10 text-blue-900 font-semibold text-base hover:bg-white transition shadow-sm"
              >
                {t("learn_more")} {/* Assuming this is the translation key for "Learn More" */}
              </a>
            </div>

            <div className="flex items-center gap-8 mt-12 flex-wrap">
              <div>
                <p className="text-2xl font-bold text-primary">
                  {hero.stat1_value}
                </p>
                <p className="text-sm text-primary">
                  {hero.stat1_label}
                </p>
              </div>

              <div className="w-px h-10 bg-blue-900/20" />

              <div>
                <p className="text-2xl font-bold text-primary">
                  {hero.stat2_value}
                </p>
                <p className="text-sm text-primary">
                  {hero.stat2_label}
                </p>
              </div>

              <div className="w-px h-10 bg-blue-900/20" />

              <div>
                <p className="text-2xl font-bold text-primary">
                  {hero.stat3_value}
                </p>
                <p className="text-sm text-primary">
                  {hero.stat3_label}
                </p>
              </div>
            </div>
          </div>

          {/* Right Card */}
          <div className="hidden lg:flex justify-center ">
            <div className="relative  w-full">
              
              {/* Transparent Glass Card */}
              <div className="w-full rounded-3xl bg-white/10 backdrop-blur-xl border border-primary p-8 shadow-2xl">
                
                <CurrencyConverter />

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;